import { RefObject, useEffect } from 'react';

/**
 * Calls `onOutsideClick` when a pointer press lands outside `ref`. Only
 * listens while `active` is true so closed dropdowns cost nothing.
 */
const useClickOutside = (
	ref: RefObject<HTMLElement>,
	active: boolean,
	onOutsideClick: () => void
): void => {
	useEffect(() => {
		if (!active) return;

		const handleMouseDown = (event: MouseEvent) => {
			if (!ref.current?.contains(event.target as Node)) {
				onOutsideClick();
			}
		};

		document.addEventListener('mousedown', handleMouseDown);
		return () => document.removeEventListener('mousedown', handleMouseDown);
	}, [ref, active, onOutsideClick]);
};

export default useClickOutside;
